<template>
    <div class="intro">
        <div class="intro__content-box">
            <h1 class="intro__title">
                <slot name="title"></slot>
            </h1>
            <p class="intro__description">
                <slot name="description"></slot>
            </p>
            <div class="intro__buttons">
               <slot name="buttons"></slot>
            </div>
        </div>
        <div class="intro__image-box" v-if="type === 'image' && isDesktopView">
            <slot name="image"></slot>
        </div>
        <div class="intro__video-box" v-if="type === 'video' && isDesktopView">
            <img :src="require('@/assets/images/hero/display.png')" alt="" class="intro__video-display"/>
            <slot name="video"></slot>
            <svg @click="onPlayVideo" class="intro__video-play" fill="#ffffff" height="100px" width="100px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-35.64 -35.64 368.28 368.28" xml:space="preserve" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M148.5,0C66.486,0,0,66.486,0,148.5S66.486,297,148.5,297S297,230.514,297,148.5S230.514,0,148.5,0z M202.79,161.734 l-78.501,45.322c-2.421,1.398-5.326,2.138-8.083,2.138c-8.752,0-16.039-7.12-16.039-15.872v-90.645 c0-8.752,7.287-15.872,16.039-15.872c2.758,0,5.579,0.739,8.001,2.138l78.542,45.322c4.966,2.867,7.951,8.001,7.951,13.734 S207.756,158.867,202.79,161.734z"></path> </g></svg>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'totem-intro',
        props: {
            type: {
                type: String,
                validator: (prop) => ['image', 'video'].includes(prop),
            }
        },
        methods: {
            onPlayVideo () {
                this.$emit('on-play-video')
            }
        }
    }
</script>

<style lang="scss" scoped>
.intro {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    background: transparent;
    color: $white;
    height: 100%;

    [class*="desktop"] & {
        flex-direction: row;
    }

    &__buttons {
        width: 100%;
        display: flex;
        align-items: flex-start;
        margin-left: -5px;
        gap: 10px;

        & > div {
            min-height: 38px;
        }

        [class*="mobile_sm"] & {
            flex-direction: column;

            & > div {
                min-height: 30px;
            }
        }
    }

    &__content-box {
        padding: 0 0 30px 0;

        [class*="desktop"] & {
            max-width: 670px;
        }

        flex: 0 0 50%;
    }

    &__title {
        font-weight: 500;
        font-family: QuickSand-Regular, sans-serif;
        font-size: 2rem;
        line-height: 2.4rem;
        margin: 0 0 2.4rem;
        cursor: pointer;
        word-break: break-word;

        [class*="desktop"] & {
            font-size: 3rem;
            line-height: 4rem;
        }
    }

    &__description {
        font-family: Nunito-Regular, sans-serif;
        font-size: 1.5rem;
        margin: 0 0 2.5rem;

        [class*="desktop"] & {
            font-size: 1.8rem;
            line-height: 2.4rem;
            margin: 0 0 3rem;
        }
    }

    &__image-box {
        width: 50%;
        flex: 0 0 40%;
        display: flex;
        align-self: flex-end;

        [class*="desktop"] & {
            width: 100%;
        }
    }

    &__video-box {
        width: 528px;
        min-width: 528px;
        height: 357px;
        position: relative;
        align-self: flex-end;
        margin: 0 auto;
    }

    &__video-thumbnail {
        position: relative;
        top: 24px;
        left: 32px;
        z-index: 1;
        cursor: pointer;
    }

    &__video-display {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
    }

    &__video-play {
        position: absolute;
        top: 106px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;
        cursor: pointer;
        filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.35));

        &:hover {
            filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.35));
            path {
                transform: scale(1.1);
                transform-origin: center;
            }
        }
    }
}
</style>
